import { useEffect } from 'react';
import Log from '@deephaven/log';
var log = Log.module('useTableListener');
export var useTableListener = (eventEmitter, eventName, callback) => useEffect(function initEventEmitter() {
  if (eventEmitter == null) {
    log.debug2('Emitter undefined, skipping addEventListener', eventName);
    return;
  }
  log.debug2('Adding listener', eventName);
  return eventEmitter.addEventListener(eventName, callback);
}, [eventEmitter, eventName, callback]);
export default useTableListener;
//# sourceMappingURL=useTableListener.js.map